module.exports = __webpack_public_path__ + "static/media/Estabelecimento.c6589b0e.svg";